import { AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS, AVIS_INICIALITZAR } from '../../../actions/actionTypes';

const ESTAT_INICIAL = null;

const id = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS:
            return action.avis.id;

        default:
            return state;
    }
};

export default id;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/id.js